import { render, staticRenderFns } from "./AskModal.vue?vue&type=template&id=17a1c8fc&scoped=true&"
import script from "./AskModal.vue?vue&type=script&lang=ts&"
export * from "./AskModal.vue?vue&type=script&lang=ts&"
import style0 from "./AskModal.vue?vue&type=style&index=0&id=17a1c8fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a1c8fc",
  null
  
)

export default component.exports